import { useEffect, useState } from 'react'
import { getUserCredentials } from '../storage'

export const useAutoFillCredentials = (
  setLoginState: (state: any) => void,
  setRememberMe?: (remember: boolean) => void
) => {
  useEffect(() => {
    const savedCredentials = getUserCredentials()

    if (savedCredentials) {
      setLoginState(prev => ({
        ...prev,
        email: savedCredentials.email,
        password: savedCredentials.password || '',
        remember_me: savedCredentials.rememberMe
      }))

      if (setRememberMe) {
        setRememberMe(savedCredentials.rememberMe)
      }
    }
  }, [setLoginState, setRememberMe])
}

export const useHasStoredCredentials = () => {
  const [hasCredentials, setHasCredentials] = useState(false)

  useEffect(() => {
    const savedCredentials = getUserCredentials()
    setHasCredentials(!!savedCredentials)
  }, [])

  return hasCredentials
}
